import { Footer } from '../../components/share/Footer';
import { NavbarComponent } from "../../components/share/NavbarComponent";
import { HeadTitle } from "../../components/share/HeadTitle";
import { ConsiderProfileDetailComponent } from '../../components/RegisterSystem/ConsiderProfileDetailComponent';
// import { ConsiderRegisterDetailComponent } from "../../components/RegisterSystem/ConsiderRegisterDetailComponent";
export function ConsiderProfileDetailContainer() {
    const titleName = "รายละเอียดคำขอเปลี่ยนแปลงข้อมูลส่วนตัว";
    return (
        <div className="page-container bg-landing">
            <NavbarComponent />
            <HeadTitle title={titleName} />
            <ConsiderProfileDetailComponent />
            <Footer />
        </div>
    );
}